// Mirrored in the panel: both frontends are built and deployed independently.
export function portalOf(property = {}) {
  const source = String(property.source || '').trim().toLowerCase();
  if (['zonaprop', 'argenprop'].includes(source)) return source;
  try {
    const host = new URL(property.url).hostname.toLowerCase();
    if (host === 'argenprop.com' || host.endsWith('.argenprop.com')) return 'argenprop';
    if (host === 'zonaprop.com.ar' || host.endsWith('.zonaprop.com.ar')) return 'zonaprop';
  } catch { /* Legacy property with no URL. */ }
  return source || 'otro';
}

export function portalsOf(property = {}) {
  return [...new Set(property.portals?.length ? property.portals : [portalOf(property)])];
}

export const portalLabel = (source) => ({ zonaprop: 'Zonaprop', argenprop: 'Argenprop', otro: 'Otro portal' }[source] || source);
export function portalColors(property = {}, highlight = false, visited = false) {
  return portalsOf(property).map(source => source === 'argenprop'
    ? highlight ? '#106340' : visited ? '#509879' : '#16885a'
    : source === 'zonaprop' ? highlight ? '#a94313' : visited ? '#c97243' : '#df6624'
      : '#526879');
}

// Group keys are authoritative; never merge apartments just because coordinates match.
export function uniqueProperties(properties = []) {
  const groups = new Map();
  for (const property of properties) {
    const key = property.property_group_key || `id:${property.id}`;
    if (!groups.has(key)) groups.set(key, property);
  }
  return [...groups.values()];
}

export function preserveHistoricalProperty(snapshot, current) {
  return { ...snapshot, current_publications: current || null, is_historical: true,
    availability: current?.availability || 'unknown', group_availability: current?.group_availability || 'unknown' };
}
